import {
    Banknote,
    Calculator,
    FileSignature,
    GraduationCap,
    Megaphone,
    Stethoscope,
    IdCard,
    Landmark,
    Gavel,
    File as FileGeneric,
} from "lucide-react";

const CATEGORY_STYLES = {
    busta_paga: { Icon: Banknote, cls: "bg-emerald-50 text-emerald-600" },
    cu_730: { Icon: Calculator, cls: "bg-teal-50 text-teal-600" },
    contratto: { Icon: FileSignature, cls: "bg-blue-50 text-blue-600" },
    certificato: { Icon: GraduationCap, cls: "bg-violet-50 text-violet-600" },
    comunicazione: { Icon: Megaphone, cls: "bg-amber-50 text-amber-600" },
    visita_medica: { Icon: Stethoscope, cls: "bg-rose-50 text-rose-600" },
    documento_identita: { Icon: IdCard, cls: "bg-sky-50 text-sky-600" },
    unilav: { Icon: Landmark, cls: "bg-indigo-50 text-indigo-600" },
    atti: { Icon: Gavel, cls: "bg-orange-50 text-orange-700" },
    altro: { Icon: FileGeneric, cls: "bg-slate-100 text-slate-500" },
};

export const CategoryIcon = ({ category, label, className = "" }) => {
    const { Icon, cls } = CATEGORY_STYLES[category] || CATEGORY_STYLES.altro;
    return (
        <span
            className={`inline-flex h-7 w-7 flex-shrink-0 items-center justify-center rounded-md ${cls} ${className}`}
            title={label || category}
            data-testid="category-icon"
        >
            <Icon className="h-4 w-4" />
        </span>
    );
};
